import { render, staticRenderFns } from "./SaberAccountsTab.vue?vue&type=template&id=18711045"
import script from "./SaberAccountsTab.vue?vue&type=script&lang=js"
export * from "./SaberAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports